import React from 'react';
import { Grid, Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
	rootPaper: {
		width: 200,
		height: 200,
		borderRadius: 100,
		backgroundColor: '#198754',
    color: '#ffffff',
    padding: 20,
    fontSize: '1.2em',
    textAlign: 'center'
	},
});

const AboutProcess = ({text}) => {
	const classes = useStyles();
	return (
		<Paper className={classes.rootPaper}>
			<Grid
				container
				justifyContent='center'
				alignItems='center'
				style={{ height: '15vh' }}
			>
				<Grid item>{text}</Grid>
			</Grid>
		</Paper>
	);
};

export default AboutProcess;
